export default {
	primary: '#0233cc'
}


// WEBPACK FOOTER //
// ./src/themes/strongblueTheme.js